"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function Report(_a) {
    var channel = _a.channel, voucher_id = _a.voucher_id, emails = _a.emails;
    var _b = react_1.useState(false), open = _b[0], setOpen = _b[1];
    var vouchers = ra_fetch_1.useApi('ecommerce').index('vouchers', {
        parent_id: voucher_id,
        channel_id: channel.id,
    })[0];
    if (vouchers.loading || !vouchers.data.length) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var send = vouchers.data.filter(function (voucher) { return voucher.send; }).length;
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3', className: 'font-light p-2 bg-green-200 rounded-lg' },
            "verzonden naar ",
            react_1.default.createElement("span", { className: 'font-semibold' }, send),
            " ",
            send === 1 ? 'fan' : 'fans'),
        react_1.default.createElement("div", { className: 'w-full' },
            react_1.default.createElement("div", { className: 'flex justify-end' },
                react_1.default.createElement(storybook_1.Buttons.Button, { onClick: function () { return setOpen(!open); }, type: 'light' },
                    open ? 'Sluit' : 'Bekijk',
                    " rapport"))),
        open && react_1.default.createElement("ul", { className: 'overflow-scroll max-h-60' }, vouchers.data.map(function (voucher, index) {
            return react_1.default.createElement("li", { className: 'flex items-center', key: index },
                react_1.default.createElement("div", { className: 'w-8' }, voucher.send !== 0 &&
                    react_1.default.createElement("div", { className: 'w-3.5 h-3.5 bg-secondary rounded-full flex justify-center items-center' },
                        react_1.default.createElement(storybook_1.Icons.Icon, { name: 'check', className: 'text-white w-3' }))),
                react_1.default.createElement(storybook_1.Texts.Primary, { className: !voucher.send ? 'text-disabled' : '' }, voucher.email));
        })));
}
exports.default = Report;
